document.addEventListener("DOMContentLoaded", function () {
  if ($('#garages-pagination').length > 0) {
    let options = {
      valueNames: [ 'distance', 'price' ],
      page: 5,
      pagination: true
    };

    let garagesList = new List('garages-pagination', options);

    garagesList.sort(
      'distance',
      {
        order: 'asc'
      }
    );

    $('select#filter-by').on('change', function () {
      let val = $(this).val();

      if (val === 'distance-asc') {
        garagesList.sort(
          'distance',
          {
            order: 'asc'
          }
        );
      }

      if (val === 'price-asc') {
        garagesList.sort(
          'price',
          {
            order: 'asc'
          }
        );
      }

      if (val === 'distance-desc') {
        garagesList.sort(
          'distance',
          {
            order: 'desc'
          }
        );
      }

      if (val === 'price-desc') {
        garagesList.sort(
          'price',
          {
            order: 'desc'
          }
        );
      }
    });
  }
});
